import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { isMobile } from "app/main/functions";
import {
    getTonlineBrowserInformation,
    isLive,
    setPageCategoryLevel,
    queryContentID,
    placeTagmanagerScript,
    queryContentType
} from "./functions";

const GTM_ID = "GTM-P9FVTRJ";

declare global {
    interface Window {
        dataLayer: any;
    }
}

interface Props {
    title: string | undefined;
}

const staticDatalayer = {
    contentAuthor: "",
    contentEvergreen: "0",
    contentFolderPath: "",
    contentFormat: "unknown",
    contentFotoshowIncluded: "ohne Fotoshow",
    contentKeywords: "",
    contentWeblines: "0",
    contentKommentartoolIncluded: "Kommentare AUS",
    contentNewsJournal: "news",
    contentProvider: "",
    contentSectionPath: "Wirtschaft & Finanzen,Börse & Märkte",
    contentType1: "0",
    contentVideoIncluded: "ohne Video",
    firstPublicationDateDay: "17.11.2020",
    firstPublicationDateTimestamp: "17.11.2020 12:00:00",
    gaClientId: "",
    lastUpdate: "",
    modificationDateDay: "",
    modificationDateTimestamp: "",
    ressort: "finanzen",
    wordCount: "1",
    wordCountRange: "Kurz"
};

export const Tagmanager = ({ title }: Props) => {
    const router = useRouter();
    useEffect(() => {
        const [tonlineBrowserVersion, tonlineBrowserInstallerID] = getTonlineBrowserInformation();
        window.dataLayer = [
            {
                pageName: title ? title : "",
                tonlineBrowserVersion,
                tonlineBrowserInstallerID,
                tonlineBrowser: navigator.userAgent.search(/TO-Browser/) > -1,
                contentType: queryContentType(router.query),
                contentID: queryContentID(router.query),
                contentDocumentTitle: title ? title : "",
                systemType: isLive() ? "live" : "preview",
                deviceClass: isMobile() ? "smartphone" : "desktop",
                isInternalIp: typeof localStorage.TisInternal !== "undefined" ? true : false,
                ...staticDatalayer,
                ...setPageCategoryLevel(location.pathname)
            },
            {
                "gtm.start": new Date().getTime(),
                event: "gtm.js"
            }
        ];
        placeTagmanagerScript(GTM_ID);
    }, []);

    return (
        <noscript>
            <iframe
                src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
                height="0"
                width="0"
                style={{ display: "none", visibility: "hidden" }}
            ></iframe>
        </noscript>
    );
};
